import { isString } from '@grandvisionhq/utils';

const getMetaTitle = (variant, product)=>[
        variant.metaTitle,
        product.metaTitle,
        variant.displayName
    ].find(isString)
;
const getMetaDescription = (variant, product)=>[
        variant.metaDescription,
        product.metaDescription,
        variant.description,
        product.description
    ].find(isString)
;

export { getMetaDescription, getMetaTitle };
//# sourceMappingURL=get-product-seo-info.js.map
